import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';
// import { setInterval as wSetInterval, clearInterval as wClearInterval } from 'worker-timers';
import { SelectCameraInputButtonComponent } from '../../shared/new-slick/select-camera-input-button/select-camera-input-button.component';
import { fabric } from 'fabric'; // browser
import { NgZone } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { WebGLVideo } from './webgl-video'; // Import the WebGLVideo class
import { WebGLImage } from './webgl-image';
import { WebGLSample } from './webgl-sample';

@Component({
  selector: 'app-gpu',
  imports: [SelectCameraInputButtonComponent, MatTabsModule],
  templateUrl: './gpu.component.html',
  styleUrls: ['./gpu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class GPUComponent {
  readonly recordVideoElementRef = viewChild.required<ElementRef>('recordedVideo');
  readonly videoInput = viewChild('videoInput', { read: ElementRef });
  readonly testVideoInputSam = viewChild<ElementRef<HTMLVideoElement>>('testVideoInputSam');
  readonly webGLCanvas = viewChild<ElementRef<HTMLCanvasElement>>('webGLCanvas');
  readonly sampleCanvas = viewChild<ElementRef<HTMLCanvasElement>>('sampleCanvas');
  recordVideoElement!: HTMLVideoElement;
  isRecording: boolean = false;
  isVideo = false;
  isAnimationFrame = false;
  isSamVideo = false;
  haveSampleCanvas: boolean = false;
  haveWebGLCanvas: boolean = false;
  videoStream!: MediaStream;
  audioStream!: MediaStream;
  combinedStream: MediaStream;
  recordedBlobs!: Blob[];
  mediaRecorder: any;
  downloadUrl!: string;
  fabricCanvas: fabric.Canvas;
  recordingCanvas2dCtx: CanvasRenderingContext2D;

  videoConstraints = {
    video: { width: 1280, height: 720 },
  };
  audioConstraints = {
    audio: { echoCancellation: true },
  };

  rawFrames = 0;
  workerFrames = 0;
  renderFrames = 0;
  canvasRefreshFrame = 0;
  fabricCanvasRefreshFrame = 0;
  lastRawTime = performance.now();
  lastWorkerTime = performance.now();
  lastRenderTime = performance.now();
  lastCanvasRenderTime = performance.now();
  lastFabricCanvasRenderTime = performance.now();
  rawFps = 0;
  workerFps = 0;
  renderFps = 0;
  targetFps: number = 30;
  recorderLoopInterval: number;
  canvasRefreshFps = 0;
  fabricCanvasRefreshFps = 0;
  frameCount = 0;
  startTime = Date.now();
  cameraDeviceId: string = '';
  canvasGLContext!: WebGLRenderingContext;
  filter = null;
  texture: WebGLTexture;
  squareRotation = 0.0;
  deltaTime = 0;
  then = 0;
  webGLVideo: WebGLVideo;
  webGLImage: WebGLImage;
  webGLSample: WebGLSample;

  constructor(private ngZone: NgZone) {}

  async ngOnInit() {}

  async ngOnDestroy() {
    this.stopTracks();
    if (this.filter) {
      this.filter.destroy();
    }
    if (this.idx) {
      cancelAnimationFrame(this.idx);
    }
  }

  addSampleCanvas() {
    console.log('addSampleCanvas');
    this.haveSampleCanvas = !this.haveSampleCanvas;

    this.webGLSample = new WebGLSample(this.videoInput().nativeElement, this.sampleCanvas().nativeElement);
    this.webGLSample.init();
    this.webGLSample.drawSampleScene();
  }

  addWebGLCanvas() {
    console.log('addWebGLCanvas');
    this.haveWebGLCanvas = !this.haveWebGLCanvas;

    //this.webGLImage = new WebGLImage(this.videoInput.nativeElement, this.webGLCanvas.nativeElement);
    //this.webGLImage.initImage();
    //this.webGLImage.initTriangle();

    this.webGLVideo = new WebGLVideo(this.videoInput().nativeElement, this.webGLCanvas().nativeElement);
    this.webGLVideo.init();
    //this.webGLVideo.initImage();
    this.webGLVideo.drawVideoScene();
  }

  removeSampleCanvas() {
    console.log('removePlayCanvas');
  }

  async createWebGLCanvas() {
    console.log('createWebGLCanvas');
    return this.webGLCanvas().nativeElement.getContext('webgl');
  }

  stopTracks() {
    if (this.videoStream) {
      this.videoStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.audioStream) {
      this.audioStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.combinedStream) {
      this.combinedStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }

  async startVideo() {
    this.isVideo = true;
    this.getVideoStream();
    this.getAudioStream();
  }

  async stopVideo() {
    this.isVideo = false;
    this.reset();
  }

  idx: number;
  async startAnimationFrame() {
    console.log('starting animation frame');
    this.isAnimationFrame = true;

    this.ngZone.runOutsideAngular(() => {
      const loop = () => {
        if (!this.isAnimationFrame) {
          return;
        }
        this.idx = window.requestAnimationFrame(loop);
      };
      loop();
    });
  }

  async stopAnimationFrame() {
    this.isAnimationFrame = false;
    console.log(this.idx);
    // @ts-ignore
    window.cancelAnimationFrame(this.idx);
    // @ts-ignore
    console.log(this.idx);
    console.log('stopping animation frame');
  }

  changeBackground(background) {
    // @ts-ignore
    window.filter.changeBackground(document.getElementById('background' + background));
  }

  async getVideoStream() {
    const constraints: MediaStreamConstraints = {
      audio: false,
      video: {
        deviceId: this.cameraDeviceId,
        width: 640,
        height: 360,
      },
    };
    navigator.mediaDevices.getUserMedia(constraints).then(async (stream) => {
      this.videoStream = stream;
      this.recordVideoElement = this.recordVideoElementRef().nativeElement;
      this.videoInput().nativeElement.srcObject = this.videoStream;
    });
  }

  async startSamVideo() {
    if (!this.videoStream) {
      console.log('No video stream');
      return;
    }
    this.isSamVideo = true;
    // @ts-ignore
    this.filter = new BackgroundFilter(this.videoStream, {
      // @ts-ignore
      background: document.getElementById('background3'),
    });
    // @ts-ignore
    window.filter = this.filter;
    // @ts-ignore
    const outputStream = await this.filter.getOutput();
    this.testVideoInputSam().nativeElement.srcObject = outputStream;
  }

  async stopSamVideo() {
    this.isSamVideo = false;
    this.testVideoInputSam().nativeElement.srcObject = null;
    this.filter.destroy();
  }

  async getAudioStream() {
    navigator.mediaDevices.getUserMedia(this.audioConstraints).then((stream) => {
      this.audioStream = stream;
    });
  }

  // Combine video and audio tracks into a single MediaStream
  async combineStreams() {
    this.combinedStream = new MediaStream([
      ...this.videoStream.getVideoTracks(), // Add video tracks
      ...this.audioStream.getAudioTracks(), // Add audio tracks
    ]);
  }

  async startRecording() {
    this.recordedBlobs = [];
    const options: any = { mimeType: 'video/webm' };

    try {
      await this.combineStreams();
      this.mediaRecorder = new MediaRecorder(this.combinedStream, options);
    } catch (err) {
      console.log(err);
    }

    this.mediaRecorder.start(); // collect 100ms of data
    this.isRecording = !this.isRecording;
    this.onDataAvailableEvent();
    this.onStopRecordingEvent();
  }

  stopRecording() {
    this.mediaRecorder.stop();
    this.isRecording = !this.isRecording;
    console.log('Recorded Blobs:', this.recordedBlobs);
  }

  reset() {
    if (this.recordVideoElement) {
      this.recordVideoElement.src = '';
      this.recordVideoElement.srcObject = null;
    }
    this.stopTracks();
    this.isRecording = false;
    this.recordedBlobs = [];
    this.downloadUrl = '';
    this.videoInput().nativeElement.src = '';
    this.videoInput().nativeElement.srcObject = null;
    this.canvasRefreshFps = 0;
    this.fabricCanvasRefreshFps = 0;
    this.canvasRefreshFrame = 0;
    this.fabricCanvasRefreshFrame = 0;
    this.videoStream = null;
    this.stopSamVideo();
  }

  onDataAvailableEvent() {
    try {
      this.mediaRecorder.ondataavailable = (event: any) => {
        if (event.data && event.data.size > 0) {
          this.recordedBlobs.push(event.data);
        }
      };
    } catch (error) {
      console.log(error);
    }
  }

  onStopRecordingEvent() {
    try {
      this.mediaRecorder.onstop = () => {
        const videoBuffer = new Blob(this.recordedBlobs, {
          type: 'video/webm',
        });
        this.downloadUrl = window.URL.createObjectURL(videoBuffer); // you can download with <a> tag
        this.recordVideoElement.src = this.downloadUrl;
      };
    } catch (error) {
      console.log(error);
    }
  }

  async updateDeviceId(device: MediaDeviceInfo) {
    this.cameraDeviceId = device.deviceId;
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  update(event: any) {}
}
